import React from 'react';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { black, blueGrayLight, primaryBlue, white } from 'utils/color-styles';
import { CurrencyCode, currencyFormat } from 'utils/currencyFormat';

type Props = {
  isUpcoming: boolean;
  deductionIntent?: { amount: number; currency: CurrencyCode } | null;
  extra?: React.ReactNode;
};

export const PayrollRunInfo = ({ isUpcoming, deductionIntent, extra }: Props) => (
  <Paper
    sx={{
      py: 3,
      px: 4,
      mb: 2,
      backgroundColor: isUpcoming ? primaryBlue : blueGrayLight,
      minHeight: 150,
      borderRadius: 4,
    }}
  >
    <div style={{ display: 'flex' }}>
      {isUpcoming ? (
        <>
          <Typography style={{ color: white }}>Upcoming Payroll Deductions</Typography>
          <Typography
            style={{
              fontSize: 12,
              color: white,
              marginLeft: 4,
              opacity: 0.8,
            }}
          >
            (as of {moment(new Date()).format('MMM DD, YYYY')})
          </Typography>
        </>
      ) : (
        <Typography>Total payroll donations deducted</Typography>
      )}
    </div>
    {deductionIntent && (
      <Typography
        style={{
          fontSize: 42,
          fontWeight: 'bold',
          color: isUpcoming ? white : black,
        }}
      >
        {currencyFormat(deductionIntent.amount, deductionIntent.currency)}
      </Typography>
    )}
    {extra}
  </Paper>
);
